import { GetProductAndLanguage, GUID } from "../Common.js";
import { InitializeCustomWorker } from "../InitializeCustomWorker.js";
import { RemoveState, SetState } from "../StoreToolkit.js";
export const FileUpload = (action, pData, storeName, postEvents, headers) => {
  const {
    productCode,
    languageCode
  } = GetProductAndLanguage(window.location.pathname);
  const GetResponseHeader = function (responseType) {
    if (responseType === void 0) {
      responseType = 0;
    }
    switch (responseType) {
      case "text":
        return 1;
      case "blob":
        return 2;
      default:
        return 0;
    }
  };
  const requestOptions = {
    crossDomain: true,
    method: "POST",
    headers: {
      encType: "multipart/form-data",
      "Access-Control-Allow-Origin": "*",
      Lang: languageCode,
      App: productCode,
      ...headers
    },
    body: pData
  };
  const responseType = GetResponseHeader(headers?.ResponseType);
  const postWorker = InitializeCustomWorker(response => {
    if (typeof response !== "string" && !response.ok) {
      throw Error(response.statusText);
    }
    SetState(storeName, response?.Results ?? response);
    if (postEvents) {
      if (typeof postEvents === "function") {
        postEvents();
      } else {
        SetState(postEvents, GUID());
      }
    }
  }, error => {
    RemoveState(storeName);
    console.log("Looks like there was a problem:", error);
  });
  const payload = postWorker.payload(action, requestOptions, responseType);
  postWorker.worker.postMessage(payload);
};